import React, { useState, useMemo, useEffect } from "react";
import { Auth } from "shared/@auth/Auth";

import Loader from "shared/Loader";
import Table from "shared/Table";
import styles from "./index.module.css";
import { useEmails } from "./useEmails";

import ArchiveConfirmationModal from "./ArchiveConfirmationModal";

export default function Emails({ iboNumber, refetchContacts }) {
  const { hasPermission } = Auth.useContainer();

  const {
    data: emails,
    isLoading,
    refetch,
    emailArchivePut,
  } = useEmails(iboNumber);

  const [filteredEmails, setFilteredEmails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState("");
  const [isArchived, setIsArchived] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const filteredEmails = [];

    if (emails?.iboA) {
      emails.iboA.forEach((item) => {
        filteredEmails.push({
          email: item.email,
          emailTypes: item.emailTypes,
          emailId: item.emailId,
        });
      });
    }

    if (emails?.iboB) {
      emails.iboB.forEach((item) => {
        filteredEmails.push({
          email: item.email,
          emailTypes: item.emailTypes,
          emailId: item.emailId,
        });
      });
    }

    if (emails?.primaryEmails) {
      emails.primaryEmails.forEach((item) => {
        filteredEmails.push({
          email: item.email,
          emailTypes: item.emailTypes,
          emailId: item.emailId,
        });
      });
    }

    const sortedEmails = filteredEmails.sort((b, a) => {
      const aIncludes = a.emailTypes?.includes("Archived");
      const bIncludes = b.emailTypes?.includes("Archived");
      return aIncludes === bIncludes ? 0 : aIncludes ? -1 : 1;
    });

    setFilteredEmails(sortedEmails);
  }, [emails]);

  const handleConfirmArchive = (selectedEmail) => {
    if (!selectedEmail.emailTypes.includes("Archived")) {
      const updatedEmailTypes = [...selectedEmail.emailTypes, "Archived"];

      const updatedEmailObject = {
        emailId: selectedEmail.emailId,
        emailTypes: updatedEmailTypes,
      };

      emailArchivePut.mutateAsync(updatedEmailObject).then(() => {
        refetch();
        refetchContacts();
      });
    }
    setModalOpen(false);
  };

  return (
    <div className={styles.container}>
      {isLoading || !emails ? (
        <Loader />
      ) : (
        <>
          <Table>
            <thead className={styles.header}>
              <tr>
                <th>Email</th>
                <th>Archive</th>
              </tr>
            </thead>

            <tbody>
              {filteredEmails.map((item, index) => (
                <tr key={index}>
                  <td
                    className={
                      item?.emailTypes?.includes("Archived") && styles.disable
                    }
                  >
                    {item.email}
                  </td>

                  <td align="right">
                    {!item.emailTypes.includes("Archived") &&
                      hasPermission("membership.ibo.update") && (
                        <button
                          className={
                            item.emailTypes.includes("Archived")
                              ? styles.unarchiveBtn
                              : styles.archiveBtn
                          }
                          onClick={() => {
                            setSelectedEmail(item);
                            setIsArchived(
                              item.emailTypes.includes("Archived")
                                ? true
                                : false
                            );

                            setModalOpen(true);
                          }}
                        >
                          Archive
                        </button>
                      )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}

      <ArchiveConfirmationModal
        isOpen={modalOpen}
        onCollapse={() => setModalOpen(false)}
        onClick={() => handleConfirmArchive(selectedEmail)}
        email={selectedEmail.email}
        isArchived={isArchived}
      />
    </div>
  );
}
